/* Ymq 必須ブロック（見た目/DOMは変更しない、画像は1枚でOK、非表示は無視、名前表示、fetch/XHR もブロック） */
(function(){
  var FORM_SEL    = 'form[action*="/cart/add"]';
  var ADD_BTN_SEL = '[name="add"], .product-form__submit, button[type="submit"]';
  var BUY_NOW_SEL = '.shopify-payment-button__button, .shopify-payment-button button';

  function isVisible(el){
    if (!el) return false;
    if (el.hidden) return false;
    var s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden' || s.opacity === '0') return false;
    if (el.offsetParent === null && s.position !== 'fixed') return false;
    return true;
  }
  function labelOf(group){
    var t = (group.getAttribute('data-label') || '').trim();
    if (!t){
      var n = group.querySelector('.ymq-option-title .ymq_lable');
      t = n ? n.textContent.trim() : '';
    }
    return t || 'この項目';
  }
  function requiredGroups(form){
    var gs = Array.from(form.querySelectorAll('.ymq-options-box[data-validate="required"]')).filter(isVisible);
    Array.from(form.querySelectorAll('.ymq-option-title .ymq_lable.required')).forEach(function(lbl){
      var g = lbl.closest('.ymq-options-box') || lbl.closest('.ymq-option-item');
      if (g && isVisible(g) && gs.indexOf(g) === -1) gs.push(g);
    });
    return gs;
  }
  function hasValue(el, form){
    if (!el || el.disabled) return false;
    var t = (el.type||'').toLowerCase();
    if (t === 'hidden') return !!String(el.value||'').trim();
    if (t === 'file')   return !!(el.files && el.files.length);
    if (t === 'radio' || t === 'checkbox'){
      if (!el.name) return !!el.checked;
      try { return form.querySelectorAll('[name="'+CSS.escape(el.name)+'"]:checked').length > 0; }
      catch(e){ return Array.from(form.querySelectorAll('input[type="'+t+'"]')).some(function(n){return n.name===el.name && n.checked;}); }
    }
    if (el.tagName === 'SELECT' || t === 'select-one'){
      var v = (el.value||'').trim(); if (!v) return false;
      var opt = el.options[el.selectedIndex], txt = ((opt && opt.text)||'').toLowerCase();
      var bad = ['please select','選択','えらんで','選んで','選択してください','選択して下さい'];
      if (bad.some(function(w){return txt.indexOf(w)>=0;})) return false;
      return true;
    }
    if (t === 'number'){
      var val = el.value;
      if (val === '' || isNaN(Number(val))) return false;
      var min = el.getAttribute('min'); if (min!==null && min!=='' && !isNaN(Number(min)) && Number(val)<Number(min)) return false;
      return true;
    }
    return !!String(el.value||'').trim();
  }
  function hasOneImage(group){
    var preview = group.querySelectorAll('.ymq_upload_img_item, .ymq_upload_file_item, img.ymq_img_item[src]').length;
    var files = 0;
    Array.from(group.querySelectorAll('input[type="file"]')).forEach(function(f){
      if (f.files && f.files.length) files += f.files.length;
    });
    var hidden = Array.from(group.querySelectorAll('input[type="hidden"]:not(.ymq-hidden-input)'))
      .filter(function(h){
        var n = h.name||''; if (!n) return false;
        if (n.indexOf('empty-properties[')===0) return false;
        if (!(n.indexOf('properties[')===0 || n.indexOf('ymq[')===0)) return false;
        return !!String(h.value||'').trim();
      }).length;
    return (preview + files + hidden) >= 1; // 1枚でOK
  }
  function groupOK(group, form){
    if (!isVisible(group)) return true;
    // 画像UI
    if (group.querySelector('.ymq_upload_img_item, .ymq_upload_new, .ymq_upload_img_view, .ymq_upload_new_box, input[type="file"], .ymq-options-file-input')){
      if (!hasOneImage(group)) return false;
    }
    // 既存のエラー表示があればNG
    var err = group.querySelector('.ymq-error-box .ymq-error-item');
    if (err && err.textContent && err.textContent.trim()) return false;

    // その他フィールド（空file/empty-properties除外）
    var inputs = Array.from(group.querySelectorAll('input, select, textarea')).filter(function(el){
      if (!isVisible(el)) return false;
      var t=(el.type||'').toLowerCase();
      if (t==='file') return false;
      if (el.classList && el.classList.contains('ymq-hidden-input')) return false;
      if (t==='hidden'){
        var n = el.name||'';
        if (!(n.indexOf('properties[')===0 || n.indexOf('ymq[')===0)) return false;
      }
      return !el.disabled;
    });
    // ラジオ/チェック
    var radios = inputs.filter(function(el){return (el.type||'').toLowerCase()==='radio';});
    if (radios.length){
      var n = radios[0].name; if (!n) return false;
      try { if (form.querySelectorAll('[name="'+CSS.escape(n)+'"]:checked').length===0) return false; }
      catch(e){ if (!radios.some(function(r){return r.checked;})) return false; }
    }
    var checks = inputs.filter(function(el){return (el.type||'').toLowerCase()==='checkbox';});
    if (checks.length){
      var names = Array.from(new Set(checks.map(function(el){return el.name;}).filter(Boolean)));
      if (names.length){
        for (var i=0;i<names.length;i++){
          var nm = names[i], ok=false;
          try{ ok = form.querySelectorAll('[name="'+CSS.escape(nm)+'"]:checked').length>0; }
          catch(e){ ok = checks.some(function(c){return c.name===nm && c.checked;}); }
          if (!ok) return false;
        }
      } else if (!checks.some(function(c){return c.checked;})) { return false; }
    }
    // 残り
    for (var j=0;j<inputs.length;j++){
      var el=inputs[j], t=(el.type||'').toLowerCase();
      if (t==='radio'||t==='checkbox') continue;
      if (!hasValue(el, form)) return false;
    }
    return true;
  }
  function validate(form){
    var gs = requiredGroups(form), bad=[];
    for (var i=0;i<gs.length;i++){ if (!groupOK(gs[i], form)) bad.push(gs[i]); }
    if (bad.length){
      var names = bad.slice(0,3).map(labelOf).join('、');
      var ft = bad[0].querySelector('input,select,textarea') || bad[0];
      if (ft && ft.scrollIntoView) ft.scrollIntoView({behavior:'smooth', block:'center'});
      if (ft && ft.focus) ft.focus({preventScroll:false});
      alert('未入力/未完了の項目：' + names);
      return false;
    }
    return true;
  }

  // ----- フォーム/クリックの入口をブロック -----
  function guard(form){
    if (form.__ymqGuard) return;
    form.__ymqGuard = true;

    form.addEventListener('submit', function(e){
      if (!validate(form)){ e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);

    document.addEventListener('click', function(e){
      var btn = e.target.closest(ADD_BTN_SEL + ', ' + BUY_NOW_SEL);
      if (!btn) return;
      if (!form.contains(btn)) return;
      if (!validate(form)){ e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
  }

  // ----- ネットワーク層でもブロック（fetch / XHR） -----
  function installNetworkGuard(){
    if (window.__ymqNetGuardInstalled) return;
    window.__ymqNetGuardInstalled = true;

    // fetch
    var _fetch = window.fetch;
    if (_fetch){
      window.fetch = function(input, init){
        try{
          var url = (typeof input === 'string') ? input : (input && input.url);
          if (url && /\/cart\/add(\.js)?/i.test(url)){
            var form = document.querySelector(FORM_SEL);
            if (form && !validate(form)){
              return Promise.reject(new Error('Blocked by Ymq guard: required fields missing'));
            }
          }
        }catch(e){}
        return _fetch.apply(this, arguments);
      };
    }

    // XHR
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url){
      try { this.__isCartAdd = url && /\/cart\/add(\.js)?/i.test(String(url)); } catch(e){ this.__isCartAdd = false; }
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function(body){
      try{
        if (this.__isCartAdd){
          var form = document.querySelector(FORM_SEL);
          if (form && !validate(form)){
            try { this.abort(); } catch(e){}
            return; // ブロック
          }
        }
      }catch(e){}
      return _send.apply(this, arguments);
    };
  }

  function init(){
    document.querySelectorAll(FORM_SEL).forEach(guard);
    new MutationObserver(function(){ document.querySelectorAll(FORM_SEL).forEach(guard); })
      .observe(document.documentElement,{childList:true, subtree:true});
    installNetworkGuard();
    // 稼働マーク
    document.documentElement.setAttribute('data-ymq-guard','on');
  }

  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
